export default "__VITE_ASSET__Ba9Quu1H__"